import { ComponentRef, Injectable, ViewContainerRef, DestroyRef, EnvironmentInjector, inject } from '@angular/core';
import { FullScreenComponent } from '../components/full-screen/full-screen.component';

@Injectable({
  providedIn: 'root'
})
export class FullScreenService {
  private destroyRef = inject(DestroyRef);
  private environmentInjector = inject(EnvironmentInjector);

  componentRef!: ComponentRef<FullScreenComponent>;

  openInFullScreen<T>
    (placeToRenderRef: ViewContainerRef, viewContainerRef: ViewContainerRef, componentToResolve: any, productName = '', inputData?: any): ComponentRef<T> {

    const createdComponent = viewContainerRef.createComponent<T>(componentToResolve, {
      environmentInjector: this.environmentInjector
    });

    if (inputData && createdComponent.setInput) {
      Object.entries(inputData).forEach(([key, value]) => {
        createdComponent.setInput(key, value);
      });
    } else if (inputData && createdComponent.instance) {
      // Fallback: Direct property assignment for signal-based inputs
      Object.entries(inputData).forEach(([key, value]) => {
        const inputKey = key.endsWith('Input') ? key : `${key}Input`;
        if (typeof (createdComponent.instance as any)[inputKey] === 'function') {
          (createdComponent.instance as any)[inputKey].set(value);
        } else if (createdComponent.instance && typeof createdComponent.instance === 'object' && key in createdComponent.instance) {
          (createdComponent.instance as any)[key] = value;
        }
      });
    }

    placeToRenderRef.clear();
    this.componentRef = placeToRenderRef.createComponent(FullScreenComponent, {
      projectableNodes: [[createdComponent.location.nativeElement]]
    });

    this.componentRef.setInput('productName', productName);

    const subscription = this.componentRef.instance.close$.subscribe(() => {
      this.componentRef.destroy();
    });

    // Auto-cleanup when service is destroyed
    this.destroyRef.onDestroy(() => {
      subscription.unsubscribe();
      if (this.componentRef) {
        this.componentRef.destroy();
      }
    });

    return createdComponent;
  }
}
